import React, { useState, memo } from "react";
import { AiOutlineLike, AiOutlineDislike } from "react-icons/ai";
import MarkdownContent from "./MarkdownContent";
import {
	MessageWrapper,
	MessageBubble,
	MessageSender,
	MessageContent,
	LinkButton,
	FeedbackContainer,
	FeedbackText,
	FeedbackButton
} from "./styles";

const Message = memo(({ message, onFeedback, onWhatsAppRedirect }) => {
	const {
		id,
		content,
		label,
		type,
		isUser,
		sender,
		showFeedback,
		feedback,
		messageId
	} = message;
	const [currentFeedback, setCurrentFeedback] = useState(feedback || null);

	const handleFeedback = type => {
		const newFeedback = currentFeedback === type ? null : type;
		setCurrentFeedback(newFeedback);
		onFeedback?.(messageId || id, newFeedback);
	};

	const handleLinkClick = () => {
		if (content) {
			const isWhatsAppLink = content.includes("wa.me");

			window.open(content, "_blank", "noopener,noreferrer");

			if (isWhatsAppLink && onWhatsAppRedirect) {
				setTimeout(() => {
					onWhatsAppRedirect();
				}, 500);
			}
		}
	};

	const handleMarkdownLink = (url) => {
		const isWhatsAppLink = url.includes("wa.me");
		
		if (isWhatsAppLink && onWhatsAppRedirect) {
			setTimeout(() => {
				onWhatsAppRedirect();
			}, 500);
		}
	};

	const renderContent = () => {
		if (type === "link") {
			return (
				<LinkButton onClick={handleLinkClick}>
					{label || "Clique aqui"}
				</LinkButton>
			);
		}

		if (isUser) {
			return content;
		}

		return <MarkdownContent content={content} onLinkClick={handleMarkdownLink} />;
	};

	return (
		<MessageWrapper isUser={isUser}>
			{!isUser && sender && <MessageSender>{sender}</MessageSender>}
			<MessageBubble isUser={isUser} isLink={type === "link"}>
				<MessageContent isUser={isUser} isLink={type === "link"}>
					{renderContent()}
				</MessageContent>
			</MessageBubble>
			{showFeedback && !isUser && type !== "link" && (
				<FeedbackContainer>
					<FeedbackText>Essa resposta foi útil?</FeedbackText>
					<FeedbackButton
						active={currentFeedback === "like"}
						onClick={() => handleFeedback("like")}
						aria-label="Resposta útil"
					>
						<AiOutlineLike />
					</FeedbackButton>
					<FeedbackButton
						active={currentFeedback === "dislike"}
						onClick={() => handleFeedback("dislike")}
						aria-label="Resposta não útil"
					>
						<AiOutlineDislike />
					</FeedbackButton>
				</FeedbackContainer>
			)}
		</MessageWrapper>
	);
});

Message.displayName = "Message";

export default Message;
